import React from 'react';
import styled from 'styled-components';
import Lobster from '../../components/Lobster/Lobster';
import Target from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;



class CardLobster extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <Lobster />

    </Viz>

   <ReusableDetailCard
   trend= {Target}
   metricsm="Coastal North Atlantic"
   diagnosis="Warming sea surface temperatures are forcing populations of the American lobster (Homarus americanus) to higher latitudes than ever before—and upending fishing communities on the New England coast. "
   prediction="The number of juvenile lobsters that make it to adulthood has dropped in southern New England and risen sharply in the Gulf of Maine, indicating the optimal habitat could continue to shift north (NOAA)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
</Container>

  );
 }
}

export default CardLobster;
